import Axios from 'axios'
import * as React from 'react'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {AttachmentInfo} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {CsSelector} from '../../core/components/Controls/CsSelector'

enum CS {
  GEO = 1,
  WEB = 2,
  BG2005 = 4,
  BG2005CAD = 5,
  BG703 = 6,
  BG705 = 7,
  BG707 = 8,
  BG709 = 9,
  BG3024 = 14,
  BG3027 = 15,
  BG50324 = 10,
  BG50327 = 11,
  BG50621 = 12,
  BG50627 = 13
}

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  afterSuccess: boolean
  error: string
  CoordsX: any
  CoordsY: any
  TranslatedX: any
  TranslatedY: any
  TranslatedX2005: any
  TranslatedY2005: any
  SRCCS: CoordinateSystem
  DSTCS: CoordinateSystem
  p: any
}

export class CoordinateTranslator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      error: '',
      CoordsX: '',
      CoordsY: '',
      TranslatedX: '',
      TranslatedY: '',
      TranslatedX2005: '',
      TranslatedY2005: '',
      SRCCS: CoordinateSystem.WEB_MERCATOR,
      DSTCS: CoordinateSystem.BG2005CAD,
      p: ''
    }
  }
  getCS(cs: CoordinateSystem): number {
    switch (cs) {
      case CoordinateSystem.BG_703:
        return CS.BG703
      case CoordinateSystem.BG_705:
        return CS.BG705
      case CoordinateSystem.BG_707:
        return CS.BG707
      case CoordinateSystem.BG_709:
        return CS.BG709
      case CoordinateSystem.GEOGRAPHIC:
        return CS.GEO
      case CoordinateSystem.BGS2005:
        return CS.BG2005
      case CoordinateSystem.BG2005CAD:
        return CS.BG2005CAD
      case CoordinateSystem.BG_3024:
        return CS.BG3024
      case CoordinateSystem.BG_3027:
        return CS.BG3027
      case CoordinateSystem.BG50324:
        return CS.BG50324
      case CoordinateSystem.BG50327:
        return CS.BG50327
      case CoordinateSystem.BG50621:
        return CS.BG50621
      case CoordinateSystem.BG50627:
        return CS.BG50627
      default:
        return CS.WEB
    }
  }

  getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.SRCCS}
        onChange={s => this.setState({...this.state, error: '', SRCCS: s})}
        className="form-control"
      />
    )
  }

  getDSTProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.DSTCS}
        onChange={s => this.setState({...this.state, error: '', DSTCS: s})}
        className="form-control"
      />
    )
  }

  getResponseX = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.CoordsX}
          onChange={e => {
            this.setState({...this.state, CoordsX: e.target.value})
          }}
        ></input>
      </div>
    )
  }
  getResponseY = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={this.state.CoordsY}
          onChange={e => {
            this.setState({...this.state, CoordsY: e.target.value})
          }}
        ></input>
      </div>
    )
  }
  getSubmit = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <button
          type="button"
          className="btn btn-primary"
          style={{margin: '0 10px 0 0'}}
          disabled={!this.state.CoordsX || !this.state.CoordsY}
          onClick={() => {
            this.getTranslated()
          }}
        >
          Конвертирай
        </button>

        {this.state.error && <div style={{color: 'red', margin: '0 10px 0 0'}}>{this.state.error}</div>}
      </div>
    )
  }

  getTransX = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input className="form-control" style={{margin: '0 10px 0 0'}} value={this.state.TranslatedX} readOnly></input>
      </div>
    )
  }
  getTransY = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input className="form-control" style={{margin: '0 10px 0 0'}} value={this.state.TranslatedY} readOnly></input>
      </div>
    )
  }

  getTranslated() {
    Axios.post(config.getConfig().urls.xyApiUrl + '/BgTrans/TransPoints', {
      Coordinates: [[this.state.CoordsX, this.state.CoordsY]],
      DestinationZone: 9,
      SourceCS: this.getCS(this.state.SRCCS),
      DestinationCS: this.getCS(this.state.DSTCS)
    })
      .then(r => {
        this.setState({...this.state, TranslatedX: r.data[0][0], error: ''})
        this.setState({...this.state, TranslatedY: r.data[0][1], error: ''})
      })
      .catch(e => {
        this.setState({...this.state, error: 'Невалидни координати!'})
      })
  }

  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>
            {this.getContainer(this.getProjectionSelector(), 'SRC Координатна система', `10px 0px`)}
            {this.getContainer(this.getResponseX(), 'X', `10px 0px`)}
            {this.getContainer(this.getResponseY(), 'Y', `10px 0px`)}
            {this.getContainer(this.getSubmit(), 'Конвертиране', `10px 0px`)}
            {this.getContainer(this.getDSTProjectionSelector(), 'DST Координатна система', `10px 0px`)}
            {this.getContainer(this.getTransX(), 'X ' + this.state.DSTCS, `10px 0px`)}
            {this.getContainer(this.getTransY(), 'Y ' + this.state.DSTCS, `10px 0px`)}
          </div>
        }
      </div>
    )
  }
}
